// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__lqUPL","small":"Loader_small__ke0+L"};